import { Injectable } from '@angular/core';
import { PoliciesService, WtprService } from 'src/app/shared/services';
import colorLibJson from 'src/app/wtpr/colorLib.json';
import { NEVER, Observable, of } from 'rxjs';
import { AppService } from '../../services/app/app.service';
import { Router } from '@angular/router';
import { prefix } from '../../constants';
import { Policies } from '../../../shared/constants';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/shared/services/app-config';
import { map, tap, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalGuideService {
  activeMetric: string;
  countriesByIsoCode = {};
  countryData: any = [];
  dataIsReady;
  dataObservee;
  metrics = [];
  onDataChanged;
  _selectedCountry = '';
  selectedCountryIso;
  tableData: any = {
    columns: {
      countryName: 'Country',
    },
    rows: [],
  };
  onContainerChanged;
  getMneWorldAccess: boolean;

  constructor(
    private appService: AppService,
    private _wtprService: WtprService,
    private _router: Router,
    private _policiesService: PoliciesService,
    private http: HttpClient,
    private config: AppConfig
  ) {
    this._policiesService.getUserPolicies().subscribe((policies) => {
      this.getMneWorldAccess = policies.some((policy) =>
        policy.policyName.includes(Policies.GET_MNE_WORLD)
      );

      this.onDataChanged = new Observable<any>((obs) => {
        this.dataObservee = obs;
      });
      this.onContainerChanged = this.appService.onContainerChanged;
      this.appService.onRouteChanged.subscribe((newUrl) => {
        // TODO: This is a string constant.
        if (newUrl.includes('/global-guide')) {
          const countryIso = newUrl.split('/global-guide/').pop();
          if (this.dataIsReady) {
            this.dataIsReady.then(() => {
              if (
                this.countriesByIsoCode[countryIso] &&
                countryIso !== this.selectedCountryIso
              ) {
                this.selectedCountry = this.countriesByIsoCode[countryIso].name;
              }
              if (!this.selectedCountry) {
                // this.selectedCountry = this.countriesByIsoCode[Object.keys(this
                //   .countriesByIsoCode)[0]].name;
              }
            });
          }
        }
      });
      this.appService.onContainerChanged.subscribe(() => {
        this.selectedCountry = null;
        this.getData();
      });
      this.getData();
    });
  }
  get selectedCountry() {
    return this._selectedCountry;
  }

  set selectedCountry(value) {
    this._selectedCountry = value;
    if (this.selectedCountry !== null && this.selectedCountry !== '') {
      const { isoCode } = this.countryData.find((data) => {
        return data.name === value;
      });

      this.selectedCountryIso = isoCode;
      this._router.navigate([prefix, 'global-guide', isoCode]);
    }
  }

  /**
   * Changes the metric on the global guide.
   */
  changeMetric({ value }) {
    this.activeMetric = value;
    this.getTableData();
  }

  // TODO: Is this needed?
  generateRiskValue(): void {
    this.countryData.forEach((country) => {
      country.riskValue = colorLibJson.risk[country['1'].value];
    });
  }

  getData(): void {
    /*
    if (this._activatedRoute.snapshot.paramMap.get('id')) {
      const id = this._activatedRoute.snapshot.paramMap.get('id');

      this._wtprService.getWorldCountryData(id).subscribe(({ data }) => {
        this.countryData = this.countryIsoImageFilter(data);
      });

    } else {
    */
    if (this.getMneWorldAccess) {
      this.dataIsReady = new Promise<void>((resolve) => {
        this._wtprService.getMneData().subscribe((dat) => {
          const data = dat.data as any;
          const temp = {};
          data.forEach((country) => {
            country.metrics = {};
            country.wtpData.forEach((dataPoint) => {
              temp[dataPoint.wtpReviewType.wtpReviewTypeId] = dataPoint;
              country.metrics[dataPoint.wtpReviewType.name] = dataPoint.value;
            });
            Object.assign(country, temp);
          });
          this.countryData = data;
          this.countriesByIsoCode = {};
          this.countryData.forEach((cdata) => {
            cdata.imgSrc = `assets/img/country-imgs/${cdata.isoCode}`;
            this.countriesByIsoCode[cdata.isoCode] = cdata;
          });

          if (
            (this.selectedCountry === null || this.selectedCountry === '') &&
            this.appService.currentUrl.includes('/global-guide')
          ) {
            // this.selectedCountry = this.countriesByIsoCode[Object.keys(this
            //   .countriesByIsoCode)[0]].name;
          }

          this.getMetrics();
          this.getTableData();
          this.generateRiskValue();
          resolve();
        });
      });
    }
    // }
  }

  /**
   * Gets the metrics for the global guide.
   */
  getMetrics() {
    const metrics = {};
    this.countryData.forEach((metric) => {
      if (!metric.wtpData) {
        return;
      }
      metric.wtpData.forEach(({ wtpReviewType }) => {
        const { name } = wtpReviewType;
        metrics[name] = {
          name,
          value: name,
        };
      });
    });
    this.metrics = Object.keys(metrics).map((name) => metrics[name]);
    if (
      (!this.activeMetric || !metrics[this.activeMetric]) &&
      this.metrics.length > 0
    ) {
      this.activeMetric = this.metrics[0].value;
    }
  }

  /**
   * Gets the table data.  This utilizes the active metric to always display a
   * two column datatable.
   */
  getTableData() {
    this.tableData.columns = {
      countryName: {
        name: 'Country',
        searchable: true,
      },
      [this.activeMetric]: this.activeMetric,
    };
    this.tableData.rows =
      this.countryData.map((metric) => {
        const obj: any = {};
        obj.countryCode = metric.isoCode;
        obj.countryName = metric.name;
        if (!metric.wtpData) {
          return;
        }
        metric.wtpData.forEach(({ wtpReviewType, value }) => {
          const { name } = wtpReviewType;
          if (this.activeMetric === name) {
            obj[name] = value;
          }
        });
        return obj;
      }) || [];
  }

  /**
   * Creates a new report meta.
   */
  createReportMeta(): Observable<any> {
    return this.http.post(
      `${this.config.getTpCoreApiUrl()}/v1/report/global-guide`,
      {}
    );
  }

  /**
   * Triggers the generation of a new PDF report version.
   */
  generateReportVersion(reportId: string): Observable<any> {
    return this.http
      .post(
        `${this.config.getTpCoreApiUrl()}/v1/report/global-guide/${reportId}/version`,
        { reportId }
      )
      .pipe(map(({ data }: any) => data.versionId));
  }

  /**
   * Get the report version PDF signed url.
   */
  getReportVersionSignedUrl(
    reportId: string,
    versionId: string
  ): Observable<any> {
    return this.http
      .get(
        `${this.config.getTpCoreApiUrl()}/v1/report/global-guide/${reportId}/version/${versionId}`
      )
      .pipe(map(({ data }: any) => data.signedUrl));
  }

  /**
   * Get report metadata.
   */
  getReportMeta(): Observable<any> {
    return this.http
      .get(`${this.config.getTpCoreApiUrl()}/v1/report/global-guide`)
      .pipe(
        tap(({ data }: any) => {
          // If no report meta is available, create one.
          if (!data.hasReports) {
            const createReportMeta = async () => {
              await this.createReportMeta().toPromise();
            };

            createReportMeta();
          }
        }),
        switchMap(({ data }) => (data.hasReports ? of(data.reports[0]) : NEVER))
      );
  }
}
